"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HomeSolid: function() {
        return HomeSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const HomeSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.6477 1.73806C12.2742 1.42065 11.7258 1.42065 11.3524 1.73806L1.35237 10.2381C0.931564 10.5957 0.880394 11.2268 1.23808 11.6476C1.59577 12.0685 2.22686 12.1196 2.64767 11.7619L3.00002 11.4624V19C3.00002 20.6569 4.34317 22 6.00002 22H18C19.6569 22 21 20.6569 21 19V11.4624L21.3524 11.7619C21.7732 12.1196 22.4043 12.0685 22.762 11.6476C23.1196 11.2268 23.0685 10.5957 22.6477 10.2381L12.6477 1.73806ZM12 11C13.6569 11 15 12.3431 15 14C15 15.6569 13.6569 17 12 17C10.3431 17 9 15.6569 9 14C9 12.3431 10.3431 11 12 11Z",
        fill: "currentColor"
    })
}), "HomeSolid");
const _default = HomeSolid;
